import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'ecp-multistage-select',
    templateUrl: './multistage-select.component.html',
    styleUrls: ['./multistage-select.component.css']
})
export class MultistageSelectComponent implements OnInit {

    @Input() selectJSON = {
        'obj': {
            'list': [],
            'name': '',
            'type': ''
        }
    };
    @Output() return1 = new EventEmitter();
    public returnJSON;
    public typeList;
    public subList = '';
    public selType = 'user';
    public selSublist;
    public ret;

    // è·åä¸çº§ç®å½
    getTypeList() {
        this.typeList = [];
        for (let i in this.selectJSON) {
            this.typeList.push(i);
        }
        // console.log(this.typeList);
        alert('ç»ä»¶ä¸çº§');
        this.return1.emit(this.selType);
    }

    // è·åäºçº§ç®å½
    getSubList(listId) {
        this.selSublist = [];
        this.subList = this.selectJSON[listId]['list'];
        this.returnData();
        alert('äºçº§');
    }

    // è¿åæ°æ®
    returnData() {
        this.returnJSON = {
            'type': this.selType,
            'ids': this.selSublist
        };
        this.returnJSON = JSON.stringify(this.returnJSON);
    }



    constructor() {
    }

    ngOnInit() {
        this.getTypeList();
        console.log('this');
        console.log(this);

    }
}
